exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#billingRules {\n  padding: 0.2rem 0.17rem;\n}\n#billingRules p {\n  color: #1E283C;\n  font-size: 0.16rem;\n}\n#billingRules .serial-number {\n  float: left;\n  width: 0.3rem;\n}\n#billingRules .content {\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/billingRules/index.less
// module id = 275
// module chunks = 0